import { render, staticRenderFns } from "./PcDialog.vue?vue&type=template&id=c0a077de&scoped=true&"
import script from "./PcDialog.vue?vue&type=script&lang=js&"
export * from "./PcDialog.vue?vue&type=script&lang=js&"
import style0 from "./PcDialog.vue?vue&type=style&index=0&id=c0a077de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a077de",
  null
  
)

export default component.exports